import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';
// Copyright 2024 Sadiant Inc. All Rights Reserved. This software is subject to a license agreement. Unauthorized or unlicensed use is prohibited.
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { fromEvent } from 'rxjs';
import { EnvConfig } from '../../shared/models/env-config.model';
import { menuComponentAnimation } from './menu.component.anm';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  animations: [menuComponentAnimation],
  standalone: true,
  imports: [RouterModule, CommonModule, ButtonModule, OverlayPanelModule]
})
export class MenuComponent implements OnInit, AfterViewInit {
  @ViewChild('signInMenu') signInMenu!: OverlayPanel;
  mobileMenuOpen = false;
  isHamburgerOpen: boolean = false;
  private breakpointLg: number = 992;
  clientPortalUrl!: string;
  clinicianPortalUrl!: string;
  private closeTimer: any;

  constructor(private router: Router, private envConfig: EnvConfig, @Inject(PLATFORM_ID) private platformId: any) {}

  ngOnInit(): void {
    this.clientPortalUrl = this.envConfig.clientPortalUrl;
    this.clinicianPortalUrl = this.envConfig.clinicianPortalUrl;

    if (isPlatformBrowser(this.platformId)) {
      this.router.events.subscribe(val => {
        if (val instanceof NavigationEnd) {
          window.scrollTo(0, 0);
          this.handleWindowSize(window);
        }
      });
      fromEvent(window, 'resize').subscribe(evt => {
        const window = evt.target as Window;
        this.handleWindowSize(window);
      });
    }
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => this.handleWindowSize(window));
    }
  }

  private handleWindowSize(window: Window) {
    this.isHamburgerOpen = window.innerWidth >= this.breakpointLg;
  }

  openCloseHamburger(): void {
    this.isHamburgerOpen = !this.isHamburgerOpen;
  }

  stopParentRouterLink(e: Event): void {
    e.stopPropagation();
  }
  goToExternal(url: string): void {
    if (isPlatformBrowser(this.platformId)) {
      window.open(url, '_blank');
    }
  }

  toggleMobileMenu() {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }

  closeMobileMenu() {
    this.mobileMenuOpen = false;
  }

  cancelHoverClose() {
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
    }
  }

  onSignInHoverOpen(event: Event) {
    if (!this.mobileMenuOpen) {
      this.signInMenu.show(event);
    }
  }

  onSignInHoverClose() {
    if (!this.mobileMenuOpen) {
      this.closeTimer = setTimeout(() => {
        this.signInMenu.hide();
      }, 150);
    }
  }

  cancelSignInHoverClose() {
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
    }
  }

  onSignInClickToggle(event: Event) {
    if (this.mobileMenuOpen) {
      this.signInMenu.toggle(event);
    }
  }
}
